// extracted by mini-css-extract-plugin
export default {"container":"DE-z","header":"EE-z","details":"FE-z","link":"GE-z"};